<template>
    <TintStyleForm :tint_style="tint_style" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import TintStyleForm from './TintStyleForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    TintStyleForm
  },
  data() {
    return {
      tint_style:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.tint_style=await APIRequest.detail('tint-styles',this.$route.params.id)
    this.loaded=true
  }
}
</script>
